import type { Ref } from 'vue'

import type { BasePageContent } from '@backmarket/http-api/src/api-specs-content'

import {
  DESCRIPTION_META_TAGS,
  IMAGE_META_TAGS,
  NOINDEX_META_TAG,
  TITLE_META_TAGS,
} from '../../../utils/seo/constants'
import { createMetaForGroupedTags } from '../helpers/meta/meta'

export function useCMSMeta(data: Ref<BasePageContent | null>) {
  if (!data.value) return []

  const { meta, hideFromSearchEngine } = data.value
  const { title, description, image } = meta
  const imageUrl = image.src

  return [
    ...createMetaForGroupedTags([
      {
        tags: DESCRIPTION_META_TAGS,
        content: description,
      },
      {
        tags: TITLE_META_TAGS,
        content: title,
      },
      {
        tags: IMAGE_META_TAGS,
        content: imageUrl,
      },
    ]),
    ...(hideFromSearchEngine === true ? [NOINDEX_META_TAG] : []),
  ]
}
